import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var shippingIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  fill: "none",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.5 16.85h6.12a.75.75 0 0 0 .75-.75V4.5a.75.75 0 0 0-.75-.75H1.5a.75.75 0 0 0-.75.75v11.6c0 .414.336.75.75.75h4",
  stroke: "currentColor",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.077 18.931a2.077 2.077 0 1 0 0-4.154 2.077 2.077 0 0 0 0 4.154Zm11.981 0a2.077 2.077 0 1 0 0-4.154 2.077 2.077 0 0 0 0 4.154Z",
  stroke: "currentColor",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.1 7.623h5.957l2.185 3.264v5.967h-2.327",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.91 19.5H1.09c-.603 0-1.091.448-1.091 1v.5h24v-.5c0-.552-.488-1-1.09-1h.001Z",
  fill: "currentColor"
}));

export { shippingIcon as default };
//# sourceMappingURL=shippingIcon.js.map
